import { createFileRoute, redirect } from "@tanstack/react-router";
import { me } from "@/api/auth";
import { clearTokens, getToken } from "@/api/client";

// The authenticated landing page: always redirect to /dashboard, or to
// /login when there's no token or the stored token turns out to be invalid.
// Dashboard is visible to every admin regardless of role (see _app.tsx's
// `itemVisible`/'any' handling) and each of its tiles independently
// self-gates, so there's no longer a role-priority cascade to pick from.
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    if (typeof window === "undefined") {
      throw redirect({ to: "/login" });
    }

    const token = getToken();
    if (!token) {
      throw redirect({ to: "/login" });
    }

    try {
      await me();
    } catch {
      clearTokens();
      throw redirect({ to: "/login" });
    }

    throw redirect({ to: "/dashboard" });
  },
});
